import { Link } from 'react-router-dom';
import { ArrowRightIcon, XMarkIcon } from '@heroicons/react/20/solid';
import styles from './AcademicUpgradeRibbon.module.css';

type AcademicUpgradeRibbonProps = {
  topPx: number;
  onDismiss: () => void;
};

export default function AcademicUpgradeRibbon({ topPx, onDismiss }: AcademicUpgradeRibbonProps) {
  return (
    <aside className={styles.ribbon} style={{ top: topPx }} aria-label="Academic plan promotion">
      <div className={styles.ribbonRow}>
        <div className={styles.inner}>
          <p className={styles.text}>
            You are only seeing part of DISGENET with your academic plan —{' '}
            <span className={styles.highlight}>unlock the full dataset</span> and advanced access.
          </p>
          <Link to="/unlock-disgenet" className={styles.cta}>
            See what you&apos;re missing
            <ArrowRightIcon className={styles.icon} aria-hidden />
          </Link>
        </div>
        <button
          type="button"
          className={styles.dismiss}
          onClick={onDismiss}
          aria-label="Dismiss banner until tomorrow"
        >
          <XMarkIcon className={styles.dismissIcon} aria-hidden />
        </button>
      </div>
    </aside>
  );
}
